import {
  GET_WORKOUTS_SUCCEED,
  GET_WORKOUTS_ERROR,
  CREATE_WORKOUT_SUCCEED,
  CREATE_WORKOUT_ERROR,
  WORKOUT_UNIQUENESS_CHECK_ERROR,
  RESET_WORKOUT_UNIQUENESS_ERROR,
  GET_WORKOUT_SUCCEED,
  GET_WORKOUT_ERROR,
  DELETE_WORKOUT_ERROR,
  UNASSIGN_CLIENT_SUCCEED,
  UNASSIGN_CLIENT_ERROR,
  ASSIGN_CLIENTS_ERROR,
  RENAME_WORKOUT_ERROR,
  GET_TRAINER_EXERCIES_SUCCEED,
  GET_TRAINER_EXERCIES_ERROR,
  GET_REPS_SUCCEED,
  GET_REPS_ERROR,
  CREATE_SERIES_SUCCEED,
  CREATE_SERIES_ERROR,
  CREATE_SERIES_UNIQUENESS_ERROR,
  GET_SERIES_BY_ID_SUCCEED,
  GET_SERIES_BY_ID_ERROR,
  DELETE_SERIES_ERROR,
  EDIT_SERIES_SUCCEED,
  EDIT_SERIES_ERROR,
  EXERCISE_UNIQUENESS_CHECK_ERROR,
  CREATE_EXERCISE_SUCCEED,
  CREATE_EXERCISE_ERROR,
  RESET_EXERCISE_MODEL,
  GET_CLIENT_WORKOUT_SUCCEEDED,
  GET_CLIENT_WORKOUT_ERROR,
  ASSIGN_CLIENT_TO_WORKOUTS_ERROR,
  LOADING_STATE,
  SUBMITTIG_LOADING_STATE,
  SERIES_LOADING_STATE,
  UPDATE_SERIES_ORDER_ERROR
} from './types';

const INITIAL_STATE = {
  workouts: [],
  uniquenessError: '',
  workoutIsSaved: false,
  workout: { series: [] },
  seriesExerciesNum: '',
  seriesRepsNum: '',
  trainerExercies: [],
  reps: [],
  currentSeries: {},
  exerciseUniquenessError: '',
  newCreatedExercise: null,
  doneCreatingExercise: false,
  clientWorkouts: [],
  loading: false,
  submittingLoading: false,
  seriesLoading: false
};

export default function(state = INITIAL_STATE, action) {
  if (action.type === GET_WORKOUTS_SUCCEED) {
    return { ...state, workouts: action.payload, loading: false };
  } else if (action.type === GET_WORKOUTS_ERROR) {
    return { ...state, error: action.payload, loading: false };
  } else if (action.type === CREATE_WORKOUT_SUCCEED) {
    return { ...state, workoutIsSaved: true, uniquenessError: '', loading: false };
  } else if (action.type === CREATE_WORKOUT_ERROR) {
    return { ...state, error: action.payload, uniquenessError: '', loading: false };
  } else if (action.type === WORKOUT_UNIQUENESS_CHECK_ERROR) {
    return { ...state, uniquenessError: action.payload, loading: false };
  } else if (action.type === RESET_WORKOUT_UNIQUENESS_ERROR) {
    return {
      ...state,
      uniquenessError: '',
      workoutIsSaved: false,
      exerciseUniquenessError: ''
    };
  } else if (action.type === GET_WORKOUT_SUCCEED) {
    return {
      ...state,
      workout: action.payload,
      uniquenessError: '',
      workoutIsSaved: false,
      loading: false
    };
  } else if (action.type === GET_WORKOUT_ERROR) {
    return {
      ...state,
      error: action.payload,
      uniquenessError: '',
      workoutIsSaved: false,
      loading: false
    };
  } else if (action.type === DELETE_WORKOUT_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === UNASSIGN_CLIENT_SUCCEED) {
    return {
      ...state,
      workout: { ...state.workout, ...action.payload }
    };
  } else if (action.type === UNASSIGN_CLIENT_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === ASSIGN_CLIENTS_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === GET_TRAINER_EXERCIES_SUCCEED) {
    return { ...state, trainerExercies: action.payload };
  } else if (action.type === GET_TRAINER_EXERCIES_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === GET_REPS_SUCCEED) {
    return { ...state, reps: action.payload };
  } else if (action.type === GET_REPS_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === CREATE_SERIES_SUCCEED){
    return { ...state, submittingLoading: false };
  } else if (action.type === CREATE_SERIES_ERROR) {
    return { ...state, error: action.payload, submittingLoading: false };
  } else if (action.type === CREATE_SERIES_UNIQUENESS_ERROR) {
    return { ...state, uniquenessError: action.payload, submittingLoading: false };
  } else if (action.type === GET_SERIES_BY_ID_SUCCEED) {
    return { ...state, currentSeries: action.payload, seriesLoading: false };
  } else if (action.type === GET_SERIES_BY_ID_ERROR) {
    return { ...state, error: action.payload, seriesLoading: false };
  } else if (action.type === DELETE_SERIES_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === EDIT_SERIES_SUCCEED) {
    return { ...state, submittingLoading: false };
  }  else if (action.type === EDIT_SERIES_ERROR) {
    return { ...state, error: action.payload, submittingLoading: false };
  } else if (action.type === EXERCISE_UNIQUENESS_CHECK_ERROR) {
    return { ...state, exerciseUniquenessError: action.payload };
  } else if (action.type === CREATE_EXERCISE_SUCCEED){
    return { ...state, doneCreatingExercise: true, newCreatedExercise: action.payload };
  } else if (action.type === CREATE_EXERCISE_ERROR) {
    return { ...state, error: action.payload };
  } else if(action.type === RESET_EXERCISE_MODEL) {
    return {
      ...state,
      exerciseUniquenessError: '',
      newCreatedExercise: null,
      doneCreatingExercise: false
    };
  } else if (action.type === GET_CLIENT_WORKOUT_SUCCEEDED) {
    return {
      ...state,
      clientWorkouts: action.payload.workouts,
      loading: false
    };
  } else if (
    action.type === GET_CLIENT_WORKOUT_ERROR ||
    action.type === RENAME_WORKOUT_ERROR
  ) {
    return { ...state, error: action.payload, loading: false };
  } else if (action.type === ASSIGN_CLIENT_TO_WORKOUTS_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === LOADING_STATE) {
    return { ...state, loading: true }
  } else if (action.type === SUBMITTIG_LOADING_STATE) {
    return { ...state, submittingLoading: true }
  } else if (action.type === SERIES_LOADING_STATE) {
    return { ...state, seriesLoading: true }
  } else if (action.type === UPDATE_SERIES_ORDER_ERROR) {
    return { ...state, error: action.payload };
  } else {
    return state;
  }
}
